module.exports = __webpack_public_path__ + "static/media/leading-mental-health-large@3x.a76ff556.png";